export const INSTRUMENTS = [
  {
    id: "bass-guitar",
    label: "Bass Guitar",
    value: "Bass Guitar",
    slug: "bass",
    group: "Guitars",
    color: "#34ace0",
    icon: "Bass",
    aliases: ["bass", "bass guitar", "chitara bass"],
  },
  {
    id: "electric-guitar",
    label: "Electric Guitar",
    value: "Electric Guitar",
    slug: "electric-guitar",
    group: "Guitars",
    color: "#f093fb",
    icon: "ElectricGuitar",
    aliases: ["electric guitar", "guitar electric", "chitara electrica", "guitar"],
  },
  {
    id: "acoustic-guitar",
    label: "Acoustic Guitar",
    value: "Acoustic Guitar",
    slug: "acoustic-guitar",
    group: "Guitars",
    color: "#ffb347",
    icon: "AcousticGuitar",
    aliases: ["acoustic guitar", "chitara acustica"],
  },
  {
    id: "piano",
    label: "Piano",
    value: "Piano",
    slug: "piano-keys",
    group: "Keyboards",
    color: "#667eea",
    icon: "Piano",
    aliases: ["piano", "clape", "keys", "keyboard"],
  },
  {
    id: "drums",
    label: "Drums",
    value: "Drums",
    slug: "drums-percussion",
    group: "Percussion",
    color: "#feca57",
    icon: "Drums",
    aliases: ["drums", "percussion", "tobe", "cajon"],
  },
  {
    id: "vocals",
    label: "Vocals",
    value: "Vocals",
    slug: "vocals",
    group: "Vocals",
    color: "#4facfe",
    icon: "Vocals",
    aliases: ["voice", "cantec", "canto", "singing"],
  },
  {
    id: "music-production",
    label: "Music Production",
    value: "Music Production",
    slug: "music-production",
    group: "Production",
    color: "#a855f7",
    icon: "GraphicEq",
    aliases: ["production", "mixing", "mastering", "daw", "recording"],
  },
];

export const INSTRUMENT_VALUES = INSTRUMENTS.map(i => i.value);
